import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MediaLibraryComponent} from './media-library.component';
import {UploadMediaComponent} from './upload-media/upload-media.component';
import {BrowseMediaComponent} from './browse-media/browse-media.component';
import {SharedModule} from '../shared/shared.module';
import { NgUploaderModule } from 'ngx-uploader';
import {MediaFolderComponent} from './browse-media/media-folder/media-folder.component';
import {CreateMediaFolderComponent} from './browse-media/create-media-folder/create-media-folder.component';
import {FormsModule} from '@angular/forms';
import {Ng2CompleterModule} from 'ng2-completer';
import {MediaItemComponent} from './browse-media/media-item/media-item.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    Ng2CompleterModule
  ],
  entryComponents: [MediaLibraryComponent],
  declarations: [MediaLibraryComponent, UploadMediaComponent, BrowseMediaComponent,
    MediaFolderComponent, CreateMediaFolderComponent, MediaItemComponent]
})
export class MediaLibraryModule { }



// WEBPACK FOOTER //
// ./src/app/media-library/media-library.module.ts